export default "__VITE_ASSET__G4unHCle__"